import { STORAGE_KEYS, QUERY_PARAMS } from '../../common/consts';
import { emitRegionChange } from './security';

// adds the username query param to the change region url (if applicable) so that
// the users username is 'remembered' cross-region.
const updateRegionLinks = () => {
	const username = window.localStorage.getItem(STORAGE_KEYS.USERNAME);
	const rememberUsername = window.localStorage.getItem(STORAGE_KEYS.REMEMBER_USERNAME);

	if (rememberUsername === 'true' && username) {
		document.querySelectorAll('a.region-button').forEach(el => {
			const urlBase = el.href;
			const prefix = urlBase.indexOf('?') === -1 ? '?' : '&';
			const additionalQueryString = `${prefix}${QUERY_PARAMS.USERNAME}=${username}`;
			el.href = `${urlBase}${additionalQueryString}`;
		});
	}

	let healthCheckLink = document.querySelector('a.landing__link');
	healthCheckLink.href = `${healthCheckLink.href}/browser`;
};

const addCloseListener = () => {
	document.querySelector('.landing__close').addEventListener('click', function () {
		if (typeof fin !== 'undefined') {
			var application = fin.desktop.Application.getCurrent();
			application.close();
		}
	});
};
const updateNonstpPage = () => {
	if (window.location.hostname.includes('-external')) {
		document.querySelector('h1').innerHTML += '<br>External';
	}
};

const addFocusedModeListeners = () => {
	const isEmbedded = window.self !== window.top && window.parent;
	if (isEmbedded) {
		document.querySelectorAll('a.region-button').forEach(el => {
			el.addEventListener('click', e => {
				try {
					const href = el.getAttribute('href');
					const region = el.getAttribute('data-region');
					if (region) emitRegionChange({ region: region });
					setTimeout(() => {
						window.location = href;
					}, 50);
					e.stopPropagation();
					e.preventDefault();
				} catch (e) {
					console.error(e);
				}
			});
		});
	}
};

/*global fin */
const init = function () {
	addCloseListener();
	updateRegionLinks();
	updateNonstpPage();
	addFocusedModeListeners();
};

export default init;
